(function (factory) {

	if (typeof define === "function" && define.amd)
		define('bootstrap.carousel',["jquery", "bootstrap"], factory);
	else
		factory(jQuery);

}(function ($) {
	"use strict";

	$(document).ready(function () {
		$('[data-ride="carousel"]').each(function () {
			var $carousel = $(this);
			$carousel.carousel($carousel.data());
		});
	});


	$(document).on("slid.bs.carousel", function (e) {
		var $carousel = $(e.target);
		var $captions = $carousel.find(".carousel-override-content > .item-caption");

		var current = $carousel.find(".carousel-inner > div").index($carousel.find(".carousel-inner > div.active")) + 1;
		var total = $carousel.find(".carousel-inner > div").length;

		$carousel.find(".carousel-override-header-text").text(current + " / " + total);

		$captions.hide();

		if ($captions.length >= current)
			$($captions[current - 1]).show();
	});

}));
